// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
import { CountriesLocaleEnum, StorageLocalEnum } from '@openbank/ziniaweb-ui-core-models';
// Resolvers
import {
  fetchLanguageResolver,
  fetchLanguagesConfigurationResolver,
} from '../resolvers/internationalization.resolvers';
// Types
import { InternationalizationBuilderHandlersType } from './types/internationalization-builder.handlers.type';
import { InternationalizationBuilderReturnHandlersType } from './types/internationalization-builder-return.handlers.type';
import { InternationalizationDownloadHandlersType } from './types/internationalization-download.handlers.type';
// Utils
import { newTranslationsVersionAvailable } from './utils/internationalization.handlers.utils';

const updateTranslationsInformationFlag =
  () =>
  (prevFlags: AppInformationNeedEnumeration[]): AppInformationNeedEnumeration[] =>
    [...prevFlags, AppInformationNeedEnumeration.TRANSLATIONS];

const downloadNewLanguageMessages = async ({
  response,
  setError,
  setFetching,
  setInformationFlags,
  setTranslations,
}: InternationalizationDownloadHandlersType): Promise<void> => {
  const { language, downloadUrl, lastChangedVersion } = response;

  if (!downloadUrl) {
    setError(true);
    setFetching(false);
  }

  const [entries, error] = await fetchLanguageResolver(downloadUrl || '');

  if (error) {
    setFetching(false);
    setError(error);
  } else {
    setTranslations(entries);
    localStorage.setItem(StorageLocalEnum.TRANSLATIONS, JSON.stringify(entries));
    localStorage.setItem(StorageLocalEnum.VERSION, lastChangedVersion);
    localStorage.setItem(StorageLocalEnum.LANGUAGE, language);
    setInformationFlags(updateTranslationsInformationFlag());
    setFetching(false);
  }
};

const fetchTranslationsHandler = async ({
  locale,
  setError,
  setFetching,
  setInformationFlags,
  setTranslations,
}: InternationalizationBuilderHandlersType): Promise<void> => {
  setFetching(true);
  localStorage.setItem(StorageLocalEnum.LANGUAGE, CountriesLocaleEnum.SPAIN);
  localStorage.setItem(StorageLocalEnum.LOCALE, CountriesLocaleEnum.SPAIN);

  const [response, error] = await fetchLanguagesConfigurationResolver(locale);

  if (error) {
    setError(true);
  } else if (response && newTranslationsVersionAvailable(response)) {
    await downloadNewLanguageMessages({
      response,
      setFetching,
      setError,
      setInformationFlags,
      setTranslations,
    });
  } else {
    setInformationFlags(updateTranslationsInformationFlag());
    setFetching(false);
  }
};

const InternationalizationHandlers = (
  props: InternationalizationBuilderHandlersType
): InternationalizationBuilderReturnHandlersType => ({
  handleFetchTranslations: () => fetchTranslationsHandler(props),
});

export default InternationalizationHandlers;
